import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { path } from "../../../utils";
import Footer from "../inc/Footer";
import "./RefundPolicy.scss";
import Header from "../inc/Header";
class RefundPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    let { language } = this.props;
    return (
      <>
        <Header />
        {language === "vi" ? (
          <div className="container refund">
            <div className="intro">
              <h2>CHÍNH SÁCH & ĐIỀU KHOẢN DỊCH VỤ</h2>
              <p>Áp dụng cho tất cả khách hàng tại Việt Nam</p>
              <p>
                Công ty TNHH Hải Phước – Nhà phân phối chính thức thiết bị phân
                tích cơ thể Anovator A5
              </p>
            </div>
            <section>
              <h2>2. CHÍNH SÁCH HOÀN TIỀN</h2>
              <p>
                Chúng tôi áp dụng chính sách hoàn tiền linh hoạt trong 30 ngày
                để bạn an tâm trải nghiệm thiết bị.
              </p>

              <h4>✅ Được hoàn tiền nếu:</h4>
              <ul>
                <li>
                  Sản phẩm chưa sử dụng, còn nguyên tem niêm phong, đầy đủ phụ
                  kiện
                </li>
                <li>
                  Có hóa đơn, mã đơn hàng, hoặc thông tin xác minh từ hệ thống
                </li>
                <li>
                  Lý do chính đáng: sản phẩm bị lỗi kỹ thuật, giao sai mẫu, hoặc
                  bạn đổi ý trong thời hạn quy định
                </li>
              </ul>

              <h4>⏱️ Thời gian hoàn tiền:</h4>
              <ul>
                <li>Sau khi sản phẩm được kiểm tra & xác nhận hợp lệ</li>
                <li>
                  Tiền được chuyển lại qua phương thức thanh toán ban đầu trong
                  3–10 ngày làm việc
                </li>
              </ul>

              <h4>❌ Không hoàn tiền nếu:</h4>
              <ul>
                <li>
                  Sản phẩm đã qua sử dụng, mất niêm phong hoặc bị hư hỏng do lỗi
                  người dùng
                </li>
                <li>Không có bằng chứng mua hàng hoặc yêu cầu trễ hạn</li>
              </ul>
            </section>
            <div className="contact-info support">
              <h2>THÔNG TIN LIÊN HỆ HỖ TRỢ</h2>
              <p>
                Công ty TNHH Hải Phước – Nhà phân phối Anovator chính thức tại
                Việt Nam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Điện thoại:</strong> 0359.951.5131 (Phước)
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Văn Phòng Chính - Top Fitness Center:</strong>
                <br />
                227 - 229 Hà Huy Giáp, Phường Thạnh Lộc, Quận 12
              </p>
            </div>
          </div>
        ) : (
          <div className="container refund">
            <div className="intro">
              <h2>POLICIES & TERMS OF SERVICE</h2>
              <p>Applicable to all customers in Vietnam</p>
              <p>
                Hai Phuoc Co., Ltd - Official Distributor of Anovator A5 Body
                Composition Analyzer
              </p>
            </div>
            <section>
              <h2>2. REFUND POLICY</h2>
              <p>
                Enjoy a flexible 30-day refund policy for a worry-free
                experience.
              </p>

              <h4>✅ Eligible for Refund If:</h4>
              <ul>
                <li>Product is unused, sealed, and includes all accessories</li>
                <li>Valid invoice/order ID or verified purchase record</li>
                <li>
                  Reasonable grounds: technical faults, incorrect item, or
                  change of mind within policy window
                </li>
              </ul>

              <h4>⏱️ Refund Timeline:</h4>
              <ul>
                <li>Issued after product inspection and validation</li>
                <li>
                  Processed via the original payment method within 3–10 business
                  days
                </li>
              </ul>

              <h4>❌ Not Eligible for Refund If:</h4>
              <ul>
                <li>Product is used, unsealed, or damaged due to user error</li>
                <li>
                  No proof of purchase or request is made after the deadline
                </li>
              </ul>
            </section>
            <div className="contact-info support">
              <h2>SUPPORT CONTACT INFORMATION</h2>
              <p>
                Hai Phuoc Co., Ltd - Official Distributor of Anovator in Vietnam
              </p>
              <p>
                <strong>Website:</strong>{" "}
                <a
                  href="https://www.anovator.vn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.anovator.vn
                </a>
              </p>
              <p>
                <strong>Phone:</strong> 0989.499.889
              </p>
              <p>
                <strong>Email:</strong> support@anovator.vn
              </p>
              <p>
                <strong>Head Office - Top Fitness Center:</strong>
                <br />
                227 - 229 Ha Huy Giap Street, Thanh Loc Ward, District 12
              </p>
            </div>
          </div>
        )}

        <Footer />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RefundPolicy),
);
